<template>
    <modal
        dismissable
        :show="show"
        :container-classes="$style.termsModal"
        body-classes="p-0"
        :modal-classes="$style.termsModalDialog"
        @update:show="$emit('update:show', $event)"
    >
        <card
            class="card-form"
            :header-classes="$style.header"
            :body-classes="$style.cardBody"
        >
            <template slot="header">
                <h2 class="modal-title">Terms and Conditions</h2>
                <button
                    type="button"
                    class="close"
                    aria-label="Close"
                    @click="$emit('update:show', false)"
                >
                    <i class="tim-icons icon-simple-remove" />
                </button>
            </template>
            <div :class="$style.body">
                <el-divider />
                <h3>
                    Cabinet receiving and delivery rates effective: 01-01-24
                </h3>
                <h4>
                    This rate sheet will not apply to orders already placed with
                    the manufacturer prior to the effective date of this rate
                    sheet. Those orders that are planned to come to us will be
                    charged according to the 2023 rate sheet.
                </h4>
                <el-divider content-position="left"
                    >Standard Services</el-divider
                >
                <p>
                    Our standard base rates include receiving, inspection of
                    outer packaging, inventory verification, data entry, 14 days
                    storage, delivery to site into the garage of the home.
                    Delivery rates do not include assembly, installation of
                    cabinets, waiting time, un-boxing, inspections other than
                    outer carton/box or crate, flights of stairs, long carry,
                    non-dolly rolling surfaces or unsafe construction sites. See
                    accessorial section for additional services that are
                    available upon request.
                </p>
                <p>
                    Delivery by Design will schedule and receive inbound trucks
                    from the manufacturer into our warehouse Monday through
                    Friday 8:00 to 2:00. All LTL, Fed Ex & UPS are first come
                    first serve.
                </p>
                <p>
                    We will need a minimum of 24 hours to process all inbound
                    orders; every effort will be made to accommodate special
                    needs and requests. Once received and the inventory is
                    verified against the packing slip and or BOL the
                    dealer/designer will be notified via the dealer/designers
                    preferred contact of email, fax and or telephone. Email is
                    preferred for historical value, all information will also be
                    in the customer portal including a copy of the signed BOL,
                    POD and invoices.
                </p>
                <el-divider content-position="left"
                    >Request for Delivery Form</el-divider
                >
                <p>
                    Delivery by Design requires that a “request for delivery”
                    form be filled out prior to scheduling a deliver via the
                    customer online portal. This form includes the final
                    delivery location with contact names, phone numbers and
                    information about the delivery location such as number of
                    stairs, elevators, long carries, construction site hazards,
                    gated community information, truck height/length
                    restrictions or other specific information that would help
                    the delivery to be as successful as possible. All requests
                    for delivery are required to be made 48 hours in advance.
                </p>
                <el-divider content-position="left">Standard Rates</el-divider>
                <p>
                    <b>Receiving Fee</b>
                    <br />
                    $6.00 per cabinet, this will apply to all orders and will be
                    added to the per cabinet rate for delivery. Pantry cabinets
                    will be counted as 2 cabinets.
                </p>
                <p>
                    <b>Delivery</b>
                    <br />
                    Box rate for each zip code multiplied by the number of
                    cabinets or the minimum charge whichever is greater. There
                    will be no charge for trim and panels that are delivered
                    with cabinetry. Pantry cabinets are counted as two cabinets.
                    Please see the zip code rate sheet to find the box rate for
                    your delivery city.
                </p>
                <el-divider content-position="left"
                    >Delivery Cancellations</el-divider
                >
                <p>
                    All cancellations must be made at least 48 hours prior to
                    delivery or will be subject to a fee of 50% of the delivery
                    charge.
                </p>
                <el-divider content-position="left"
                    >Accessorial Charges</el-divider
                >
                <div :class="$style.dottedListContainer">
                    <div :class="$style.dottedList">
                        <p>Pantry cabinets will be counted as two cabinets</p>
                        <p :class="$style.dottedItem">
                            <span>In House delivery</span>
                            <span>$6.00 per cabinet</span>
                        </p>
                        <p :class="$style.dottedItem">
                            <span>Offload(meet cabinet truck)</span>
                            <span>Zip code box rate or zip code min.</span>
                        </p>
                        <p :class="$style.dottedItem">
                            <span>Stair Carry</span>
                            <span>$0.50 per cabinet per stair</span>
                        </p>
                        <p :class="$style.dottedItem">
                            <span>Deliveries via elevator</span>
                            <span>$6.00 per cabinet to any floor</span>
                        </p>
                        <p :class="$style.dottedItem">
                            <span>Blanket wrapped delivery</span>
                            <span>$6.00 per cabinet</span>
                        </p>
                        <p :class="$style.dottedItem">
                            <span>Will call fee – Cabinets</span>
                            <span
                                >$10.50 per cabinet (includes receiving fee) or
                                $45.00 min. charge</span
                            >
                        </p>
                        <p :class="$style.dottedItem">
                            <span>Will call fee – accs./trim/panels</span>
                            <span
                                >$40.00 min. charge/large orders billed at
                                $45.00 per man hour</span
                            >
                        </p>
                        <p :class="$style.dottedItem">
                            <span
                                >Labor for additional services while on
                                site</span
                            >
                            <span>$125.00/hr for a two man crew</span>
                        </p>
                        <p :class="$style.dottedItem">
                            <span>Storage charges after the first 14 days</span>
                            <span>$0.55 per cabinet per day</span>
                        </p>
                        <p :class="$style.dottedItem">
                            <span
                                >No fits or refusals due to no fault of
                                DBD</span
                            >
                            <span>Full charge</span>
                        </p>
                        <p :class="$style.dottedItem">
                            <span>Not at home due to no fault of DBD</span>
                            <span>Full charge</span>
                        </p>
                        <p :class="$style.dottedItem">
                            <span>Extra men for heavy deliveries</span>
                            <span>72.50/man hour (includes travel)</span>
                        </p>
                        <p :class="$style.dottedItem">
                            <span>Pick ups</span>
                            <span>$145.00 per hour (two man crew)</span>
                        </p>
                        <p :class="$style.dottedItem">
                            <span>COD shipments paid by DBD</span>
                            <span>15% of freight bill</span>
                        </p>
                        <p :class="$style.dottedItem">
                            <span>In house repair services</span>
                            <span>$95.00 per hour</span>
                        </p>
                        <p :class="$style.dottedItem">
                            <span>Packaging and crating</span>
                            <span>Per quote</span>
                        </p>
                        <p :class="$style.dottedItem">
                            <span>White Glove Delivery</span>
                            <span>$6.00 per cabinet</span>
                        </p>
                        <p :class="$style.dottedItem">
                            <span
                                >Transfer fee (cabinets picked up by a
                                competitor)</span
                            >
                            <span>$75.00 added to will call fee.</span>
                        </p>
                    </div>
                </div>
                <el-divider content-position="left"
                    >Appliance Deliveries with Cabinets Only</el-divider
                >
                <div :class="$style.dottedListContainer">
                    <div :class="$style.dottedList">
                        <p :class="$style.dottedItem">
                            <span>Receiving fee</span>
                            <span>$35.00 per appliance</span>
                        </p>
                        <p :class="$style.dottedItem">
                            <span>Pick up fee</span>
                            <span>$145.00 per hour</span>
                        </p>
                        <p :class="$style.dottedItem">
                            <span>Delivery into the garage (standard)</span>
                            <span>$45.00 per appliance</span>
                        </p>
                        <p :class="$style.dottedItem">
                            <span
                                >Delivery into the garage (professional 36” or
                                larger)</span
                            >
                            <span>$65.00 per appliance</span>
                        </p>
                        <p :class="$style.dottedItem">
                            <span>In home delivery with cabinets</span>
                            <span>Call for quote</span>
                        </p>
                    </div>
                </div>
                <el-divider content-position="left">Freight Claims</el-divider>
                <p>
                    Inbound freight claims will be the responsibility of the
                    dealer or designer.
                </p>
                <p>
                    Claims for damage caused by delivery by Design must be noted
                    on the delivery ticket/bill of Lading. Insurance Valuation
                    is $0.60 cents per pound per article. Full replacement
                    valuation is available upon request.
                </p>
                <el-divider content-position="left">Storage</el-divider>
                <p>
                    The first 14 days of storage are free. Items received that
                    are not side marked appropriately or that we are unable to
                    identify will accrue storage after the free 14 days. There
                    is a $30.00 research fee for items that can't be identified.
                    Please make sure all items are properly marked with the
                    company name and client side mark.
                </p>
                <el-divider content-position="left"
                    >Billing and Payment</el-divider
                >
                <p>
                    All payments are due at the time of delivery unless you have
                    an account with us or other arrangements have been made
                    prior to the delivery. Larger projects will require a 50%
                    deposit and a credit card on file prior to receiving the
                    items. Invoices on account are net 15; overdue invoices will
                    be charged 1.5% interest per month on the unpaid balance.
                    Client agrees that Delivery by Design, its agencies and
                    officers shall be entitled to collect from obligor all
                    expenses incurred in recovery of any debt or in pursuing any
                    other remedy provided by law, including but not limited to
                    reasonable attorney fees and or collection costs. If we
                    agree to bill you, all invoices are due within 15 days of
                    the delivery date. If you disagree with an invoice, it must
                    be disputed within 15 days of the delivery; Invoices over 15
                    days old will not be adjusted.
                </p>
                <p>
                    Invoices will be sent to DBD customers only, DBD will not
                    bill your customer or any third party. DBD customers will be
                    responsible for the collection of invoices and will pay DBD
                    for such invoices. In the event that DBD makes an exception,
                    the invoice will be held under the DBD customers account and
                    that DBD customer will be responsible for payment if the
                    third party does not pay.
                </p>
                <p>
                    Any claim for loss or damage will not be accepted unless
                    noted on the delivery ticket. Labor chargeback's will not be
                    accepted, replacement or repair chargeback deductions must
                    be authorized in advance, without prior approval in writing,
                    deductions from invoices will not be accepted. All claims
                    shall be in writing and shall be accompanied by the original
                    paid invoice.
                </p>
                <el-divider content-position="left"
                    >Damage Waiver and Difficult Deliveries</el-divider
                >
                <p>
                    It is the customer's responsibility to make sure there is a
                    free and clear delivery path and that all items being
                    delivered will fit through doorways, up or down the stairs
                    or through hallways and into the specified room. If the item
                    will not fit into the room requested, our delivery crew will
                    make note of that and will leave the item in the first
                    available dry space. If it is requested that we attempt to
                    get the item into the room where our delivery crew has
                    determined that it will not fit, our delivery crew will ask
                    that you fill out a damage waiver. This waiver will release
                    Delivery by Design of all liability for damage to the items
                    being delivered and or the home or business. Damage claims
                    resulting from an unclear or unsafe delivery path will not
                    be accepted. Our delivery crew will determine if it is
                    unsafe to deliver and will then place items in the first dry
                    space that is safe to deliver to. Deliveries that have
                    difficult or long carry access or where our crew must spend
                    additional time navigating around obstacles such as
                    construction debris, other trades, landscaping issues,
                    trucks blocking access etc. will be charged at the rate of
                    $145.00 per hour for the additional time or the “in house,
                    stair or elevator” fee, whichever is greater.
                </p>
                <el-divider content-position="left">Will Call Items</el-divider>
                <p>
                    All items picked up from Delivery by Design either by the
                    designer, a contractor, a third party delivery company, the
                    customer or designer's customer must inspect all goods for
                    damage or shortages and note any exceptions on the will call
                    ticket before signing for the goods for claims to be
                    accepted.
                </p>
                <p>
                    By shipping to Delivery by Design and or requesting a
                    delivery, you, your employees or any agents that you may
                    appoint agree to be bound by this agreement, our terms and
                    conditions and acknowledge that you have read the entire
                    agreement. Our delivery crew will make every attempt to have
                    the appointed contact sign for the items being delivered. If
                    the delivery contact is not available they will have someone
                    sign that may or may not be an appointed agent but this will
                    not release our customer from paying the delivery charges.
                </p>
            </div>
        </card>
    </modal>
</template>

<script>
import { Modal } from "src/components/UI";
import { Divider } from "element-ui";

export default {
    name: "TermsAndConditionsModal",
    components: {
        Modal,
        [Divider.name]: Divider,
    },
    props: {
        show: {
            type: Boolean,
            required: true,
        },
    },
};
</script>

<style module>
.termsModal {
    z-index: 1100;
}

.termsModalDialog {
    max-width: 800px;
    min-width: 650px;
}

.header {
    text-align: center;
}

.body {
    width: 650px;
}

.cardBody {
    display: flex;
    justify-content: center;
}

.dottedListContainer {
    display: flex;
    justify-content: center;
}

.dottedList {
    width: 100%;
}

.dottedItem:first-child {
    margin-top: 10px;
}

.dottedItem:last-child {
    margin-bottom: 10px;
}

.dottedItem {
    display: block;
    position: relative;
    height: 5px;
    margin: 22px 0;
    border-bottom: 2px dotted darkgray;
}

.dottedItem > * {
    position: absolute;
    background-color: #fff;
    transform: translateY(-50%);
}

.dottedItem > :first-child {
    left: 0px;
    padding-right: 2px;
}

.dottedItem > :last-child {
    right: 0px;
    padding-left: 2px;
}

@media (max-width: 767px) {
    .cardBody {
        padding: 15px 5px !important;
    }

    .dottedItem {
        border-bottom: none;
        margin: 4px 0;
        height: unset;
    }

    .dottedItem > * {
        position: relative;
        transform: unset;
        background: unset;
    }

    .dottedItem > :first-child {
        display: block;
        font-weight: bold;
    }
}
</style>
<style>
.el-divider__text {
    font-size: 18px;
}
</style>
